(ns bp-clients.tv-app.common.components.splash
  (:require
   [bp-libs.design-system.components.icons :refer [bp-logo]]
   [reagent.core :as r]))

(def ^:private default-timeout-ms 2000)

(defn splash
  [{:keys [on-end]}]
  (r/create-class
   {:component-did-mount #(js/setTimeout on-end default-timeout-ms)
    :reagent-render      (fn []
                           [:div {:class "h-screen"}
                            [:div {:class "w-full h-full min-h-screen bg-black flex items-center justify-center"}
                             [:div {:class "flex items-center justify-center"}
                              [:div {:class "h-40 text-white"}
                               [bp-logo {:width "100%" :height "100%"}]]]]])}))
